import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageWithText12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconImageWithText12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ImageWithText12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.5 2h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h1.293l2.854-2.854.205-.205.28.077L11 8.345V2.5a.5.5 0 0 0-.5-.5M12 8.982V2.5A1.5 1.5 0 0 0 10.5 1h-9A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5zm-1 .4L6.148 8.059 4.208 10H10.5a.5.5 0 0 0 .5-.5zM8.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M2 3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ImageWithText12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconImageWithText12);
